import { OnlineOrderFormatsArray as e } from "./constants.mjs";
import "@ancon/wildcat-types";
function i(r) {
  return e.filter((t) => (t & r) !== 0);
}
export {
  i as default
};
